import router from '@/router';

export default {
  // 到账号申请页面
  goAccountApplication(query) {
    MtaH5.clickStat('join', { [query]: 'true' });
    router.push({ name: 'join', query: { from: query } });
  },
  // 到登录界面
  goLogin(query, replace) {
    MtaH5.clickStat('login', { [query]: 'true' });
    if (replace) {
      router.replace({ name: 'login', query: { from: query } });
    } else {
      router.push({ name: 'login', query: { from: query } });
    }
  },
  // 到充值界面
  goCharge(query) {
    MtaH5.clickStat('startcharge', { [query]: 'true' });
    router.push({ name: 'balance' });
  },
  // 到商品详情界面
  goProductDetail(query) {
    MtaH5.clickStat('startcharge', { [query]: 'true' });
    router.push({ name: 'product' });
  },
};



// WEBPACK FOOTER //
// ./src/services/buried-point-service.js